import React from "react";
import clsx from "clsx"; // optional, helps with conditional classes

const positionClasses = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  "top-left": "bottom-full left-0 mb-2",
  "top-right": "bottom-full right-0 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  "bottom-left": "top-full left-0 mt-2",
  "bottom-right": "top-full right-0 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
};

export const Tooltip = ({ children, icon = "", title = "", text, content, position = "top", style }) => {
  return (
    <div className="relative inline-block group">
      {children}
      <div
        className={clsx(
          `absolute hidden group-hover:flex flex-col ${title === '' ? "items-center" : "items-start"} justify-center`,
          `${style?.bg || "bg-black"} ${style?.text || "text-white"} text-xs px-4 py-2 rounded-lg shadow-lg z-50`,
          `${style?.width || ""} max-w-[200px] min-w-[120px] ${title === "" ? "text-center" : ""}`,
          "transition duration-200",
          positionClasses[position] || positionClasses.top
        )}
      >
        {title !== "" &&
          <>
            <h3 className="font-semibold flex items-center gap-1 mb-2">
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <img src={icon} className="inline-block w-[1em] h-[1em]" />
            </h3>
          </>
        }
        {text && <span dangerouslySetInnerHTML={{ __html: text }} />}
        {content && <div className="mt-2 w-full">{content}</div>}
      </div>
    </div>
  );
};
